import * as React from 'react'
import Skeleton from 'react-loading-skeleton';
import { SimpleCodeBlockStyle } from './codeBlock.css';
const MermaidLoadable = React.lazy(() => import('../Mermaid/Mermaid'))
const RunkitLoadable = React.lazy(() => import('./RunkitEmbed'))
const ReactLiveLoadable = React.lazy(() => import('./ReactLive'))
const HighlightedCodeLoadable = React.lazy(() => import('./HighlightedCode'));

/* eslint-disable react/jsx-key */
const CodeBlock = ({ children: exampleCode, ...props }) => {

  const isSSR = typeof window === "undefined"

  if(isSSR)
    return <Skeleton count={5} />

  if (props['react-live']) {
    return <React.Suspense fallback={<Skeleton count={5} />}> 
      <ReactLiveLoadable exampleCode={exampleCode} />
    </React.Suspense>
  } else if (props['runkit']) {
    return <React.Suspense fallback={<Skeleton count={5} />}> 
      <RunkitLoadable exampleCode={exampleCode} nodeVersion={props['nodeVersion']} />
    </React.Suspense>
  } else if (props['className'] == "language-mermaid") {
    
    return <React.Suspense fallback={<Skeleton count={5} />}> 
            <MermaidLoadable theme={props.theme}>{exampleCode}</MermaidLoadable>
          </React.Suspense>
  }
  else if(!props['className']){
    return <code css={SimpleCodeBlockStyle}><pre>{exampleCode}</pre></code>
  }
   else {
    return <React.Suspense fallback={<Skeleton count={5} />}> 
      <HighlightedCodeLoadable exampleCode={exampleCode} />
    </React.Suspense>
  }
}

export default CodeBlock




